<script>
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";

	import { instoCapacityTypes } from "../config";

	export let name;
	export let capacity;
	export let employeeRole;
	export let authorisedToAct;
	export let disabled = null;
	export let required = null;
</script>

<h3>Institutional Investor Details</h3>

<FormRow>
	<FormColumn cols="6">
		<label for="smsfname" class:isrequired={required}>Name of company/trust/fund/superannuation fund</label>
		<input
			{disabled}
			{required}
			maxlength="1000"
			type="text"
			bind:value={name}
			id="smsfname"
			class="form-control"
		/>
	</FormColumn>
	<FormColumn cols="6">
		<label for="capacity">Capacity</label>
		<Select
			{disabled}
			bind:value={capacity}
			id="capacity"
			optionList={instoCapacityTypes}
			textProperty="name"
			valueProperty="name"
		></Select>
	</FormColumn>
</FormRow>
<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to register on behalf of the company/fund/superannuation fund"
			{required}
			id="authinst"
		></Checkbox>
	</FormColumn>
</FormRow>
